import React from 'react';

import { Entitlement, EntitlementStatus, MarketDataEntitlementTypes } from '@tradingblock/types';

export const EntitlementsItemCell: React.FunctionComponent<
  Pick<
    Entitlement,
    'status' | 'requestedMarketDataEntitlementType'
  >
> = ({ status, requestedMarketDataEntitlementType }) => {
  const isPending = status === EntitlementStatus.Pending;
  const isRejected = status === EntitlementStatus.Rejected;

  return (
    <>
      {isPending && (
        <>
          <span className="txt-sm">
            {requestedMarketDataEntitlementType !== MarketDataEntitlementTypes.Undefined &&
              requestedMarketDataEntitlementType.replace(/([A-Z])/g, ' $1').trim()}
          </span>
          <br />
          <span className="txt-sm pending">Pending</span>
        </>
      )}
      {!isPending && (
        <>
          <span className="txt-sm">
            {requestedMarketDataEntitlementType !== MarketDataEntitlementTypes.Undefined &&
              requestedMarketDataEntitlementType.replace(/([A-Z])/g, ' $1').trim()}
          </span>
          <br />
          <span className={`${isRejected ? 'neg' : 'pos'} txt-sm`}>{isRejected ? 'Rejected' : 'Approved'}</span>
        </>
      )}
    </>
  );
};
